import {useQuery} from '@aboutyou/data-fetcher';
import {useHydrationDone} from '@aboutyou/lazy-imports';
import {getIsDatadogInfoLogsConsentGiven} from '@aboutyou/storage';
import {v4 as uuidV4} from 'uuid';

export const useLogInstanceId = () => {
  const {data, isLoading, refetch} = useGeneratedLogInstanceIdQuery();

  return {
    id: data?.id ?? null,
    isLogInstanceLoading: isLoading,
    resetLoggerInstanceId: () => {
      refetch();
    },
  };
};

const useGeneratedLogInstanceIdQuery = () => {
  const isHydrationDone = useHydrationDone();

  return useQuery(
    `AuthLogInstance`,
    async () => {
      let logInstanceId = null;

      if (getIsDatadogInfoLogsConsentGiven()) {
        // the browser support for crypto.randomUUID is not great, so we use uuid as fallback
        if (typeof crypto !== 'undefined' && crypto?.randomUUID) {
          logInstanceId = crypto.randomUUID().replace(/-/g, '');
        } else {
          logInstanceId = uuidV4();
        }
      }
      return {
        id: logInstanceId,
      };
    },
    {
      enabled: isHydrationDone,
    },
  );
};
